export default "__VITE_ASSET__b1d959ee__"